import { motion } from "framer-motion";
import { Layers, Printer, PenTool, Scissors, Package } from "lucide-react";
import { AnimatedSection, fadeUp } from "@/components/motion";

const offerings = [
  { title: "Unstitched Suits", icon: Layers },
  { title: "All-Over Prints", icon: Printer },
  { title: "Custom Prints", icon: PenTool },
  { title: "Embroidered Fabrics", icon: Scissors },
  { title: "Digitally Printed Bases", icon: Printer },
  { title: "Stitched Garments", icon: Package },
];

export const OfferingsSection = () => (
  <AnimatedSection id="offerings" className="py-24 lg:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div variants={fadeUp} className="mb-16">
        <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-4">What We Do</p>
        <h2 className="text-4xl md:text-5xl font-serif tracking-tight text-foreground">Our Offerings</h2>
      </motion.div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6 lg:gap-8" data-testid="offerings-grid">
        {offerings.map((item) => (
          <motion.div
            key={item.title}
            variants={fadeUp}
            className="group p-8 lg:p-10 border border-border/50 bg-white hover:bg-background transition-colors duration-300"
          >
            <item.icon size={28} className="text-[#C5A059] mb-6" strokeWidth={1.5} />
            <h3 className="text-lg font-serif text-foreground">{item.title}</h3>
          </motion.div>
        ))}
      </div>
      <motion.p variants={fadeUp} className="mt-12 text-sm font-sans text-muted-foreground tracking-wide">
        Designed for versatility. Manufactured for scale.
      </motion.p>
    </div>
  </AnimatedSection>
);
